/* cart-samples.js - VERSIÓN FINAL Y COMPLETA (CORRECCIÓN CON MUTATION OBSERVER) */
document.addEventListener('DOMContentLoaded', function() {
    
    // Selectores del Root y el Bloque de Muestras
    const root = document.getElementById('cart-samples-root');
    const panel = document.getElementById('samples-side-panel');
    const samplesBlock = root ? root.querySelector('.cart-samples-block') : null;
    
    // Selectores del Precio del Carrito (EL ELEMENTO QUE VAMOS A OBSERVAR)
    const cartPriceElement = document.querySelector('[data-cart-final]'); 

    // Verificación inicial de elementos críticos
    if (!root || !panel || !samplesBlock || !cartPriceElement) {
        console.warn("Muestras: Elementos críticos no encontrados (root, panel, samplesBlock o cartPriceElement).");
        return;
    }

    // Obtener configuración del DOM
    const maxSelect = parseInt(root.dataset.maxSelect || '1', 10);
    const threshold = parseInt(root.dataset.threshold || '5000', 10); // Umbral en centavos (ej: 5000 = €50.00)
    
    // Selectores
    const changeBtn = document.getElementById('cart-samples-change');
    const closeBtn = document.getElementById('samples-close');
    const sampleCards = document.querySelectorAll('.sample-card');
    const samplePreviewSlot = document.getElementById('sample-preview-slot');
    
    // Variables de estado
    const STORAGE_KEY = 'selectedSampleVariantIds'; 
    let selectedVariantIds = new Set(); 
    let isSyncing = false; 

    // ⚠️ FUNCIÓN CRÍTICA: Asegúrate de que esta función actualice el Side Cart.
    function refreshCartDrawer() {
        if (window.Cart && window.Cart.refresh) {
            window.Cart.refresh(); 
        } else if (document.querySelector('cart-drawer')) {
            document.querySelector('cart-drawer').getCart();
        } else {
            console.warn('⚠️ La función de refresco del Side Cart (refreshCartDrawer) no está definida o accesible.');
        }
    }

    // --- Funciones de Estado de Carga y Panel ---

    const startLoading = () => {
        isSyncing = true;
        root.classList.add('is-loading'); 
        panel.classList.add('is-loading');
    };

    const stopLoading = () => {
        isSyncing = false;
        root.classList.remove('is-loading');
        panel.classList.remove('is-loading');
    };

    const openPanel = () => {
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add('opened');
        document.body.classList.add('samples-panel-open'); 
        updatePanelUI();
    };

    const closePanel = () => {
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.remove('opened');
        document.body.classList.remove('samples-panel-open');
    };
    
    // --- UI & Storage Functions ---
    
    const updateSelectedSampleUI = () => {
        const selectedData = [];
        sampleCards.forEach(card => {
            if (selectedVariantIds.has(card.dataset.variantId)) {
                selectedData.push({
                    title: card.dataset.productTitle,
                    imgSrc: card.dataset.img
                });
            }
        });

        if (selectedData.length === 0) {
            samplePreviewSlot.innerHTML = '<div class="no-samples"></div>';
            localStorage.removeItem(STORAGE_KEY);
            return;
        }

        const html = selectedData.map(data => `
            <div class="selected-sample-item">
                <img src="${data.imgSrc}" alt="${data.title}" style="max-width: 50px; height: auto;">
            </div>
        `).join('');

        samplePreviewSlot.innerHTML = html;
        
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(selectedVariantIds)));
    };
    
    const updatePanelUI = () => {
        const currentCount = selectedVariantIds.size;
        const limitReached = currentCount === maxSelect;

        sampleCards.forEach(card => {
            const vid = card.dataset.variantId;
            const isSelected = selectedVariantIds.has(vid);

            if (isSelected) {
                card.classList.add('is-selected');
            } else {
                card.classList.remove('is-selected');
            }

            if (limitReached && !isSelected) {
                card.classList.add('is-disabled-by-limit');
            } else {
                card.classList.remove('is-disabled-by-limit');
            }
        });
        
        const panelTitle = panel.querySelector('h2');
        if (panelTitle) {
             panelTitle.innerHTML = `Choose your complimentary sample (${currentCount} of ${maxSelect} selected)`;
        }
    };

    const loadSelectedSample = () => {
        const storedIds = localStorage.getItem(STORAGE_KEY);
        if (storedIds) {
            try {
                const ids = JSON.parse(storedIds);
                if (Array.isArray(ids)) {
                    selectedVariantIds = new Set(ids);
                    updateSelectedSampleUI();
                }
            } catch (e) {
                console.error("Error parsing stored sample data:", e);
                localStorage.removeItem(STORAGE_KEY);
            }
        }
    };

    // --- Lógica de la Regla de Carrito Vacío/Umbral ---
    // Esta función ahora solo contiene la lógica de validación/limpieza de samples.
    // La verificación de visibilidad se mueve a toggleSamplesVisibility.
    async function enforceEmptyCartRule() {
        if (isSyncing) return;

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        const existingSamples = cart.items.filter(i => 
            i.properties && i.properties.sample === 'true'
        );
        
        const cartValueExcludingSamples = cart.items.reduce((total, item) => {
            const isSample = item.properties && item.properties.sample === 'true';
            return total + (isSample ? 0 : item.final_line_price);
        }, 0);
        
        if (cartValueExcludingSamples < threshold && existingSamples.length > 0) {
            
            console.warn('🚨 Regla de umbral violada. Eliminando samples gratuitos.');
            
            selectedVariantIds.clear();
            await syncSelectedSamplesWithCart(true); 
            
            updatePanelUI();
            updateSelectedSampleUI();
            
            return true; 
        }
        
        return false; 
    }
    
    // 💡 FUNCIÓN CLAVE: Controla la visibilidad del bloque (y valida el umbral)
    async function toggleSamplesVisibility() {
        
        // 1. Obtener el precio actual directamente del elemento HTML
        const priceText = cartPriceElement.textContent; // Ej: "€25,00 EUR"
        
        // 2. Limpiar el texto para obtener solo el valor en centavos (adaptado para EUR con coma)
        let cleanPriceString = priceText.replace(/[^\d,\.]/g, '').replace(',', '').replace('.', '');

        // Si la moneda usa coma (,) como separador decimal (como €25,00), 
        // y punto (.) como separador de miles, Shopify lo da como '€25,00'
        // Lo limpiaremos como '2500' (centavos). Si es EUR, esto debería funcionar:
        // Si el precio es 1.250,00 -> 125000
        // Si el precio es 25,00 -> 2500
        let currentPriceCents;
        try {
            // Asume que el formato es X,XX (sin separador de miles) o X.XXX,XX (con separador de miles)
            // Ya que Shopify puede devolver diferentes formatos en el DOM,
            // la forma más segura es intentar limpiar el texto:
            const decimalSeparator = priceText.match(/(\.|,)(\d{2})\s*EUR/)?.[1] || ',';

            if (decimalSeparator === ',') {
                // Formato: 1.250,00 EUR -> 125000 (cents)
                cleanPriceString = priceText.replace(/[^0-9,]/g, ''); // Elimina todo excepto dígitos y coma
                cleanPriceString = cleanPriceString.replace(',', ''); // Elimina la coma (decimal)
                if (cleanPriceString.length >= 3) { // Si hay al menos X00 (ej: 500)
                    // Insertamos el punto decimal para calcular centavos
                    cleanPriceString = cleanPriceString.slice(0, -2) + '.' + cleanPriceString.slice(-2);
                }
                currentPriceCents = Math.round(parseFloat(cleanPriceString) * 100);
            } else {
                 // Formato: 1,250.00 USD/EUR -> 125000 (cents)
                 currentPriceCents = Math.round(parseFloat(cleanPriceString) * 100);
            }
            // Si la conversión falla, intenta obtener el valor del backend como fallback (más seguro):
        } catch (e) {
             console.error("Error al parsear el precio del DOM, usando fallback AJAX:", e);
             // Fallback a la llamada AJAX (opcional, pero seguro)
             const cartResponse = await fetch('/cart.js');
             const cart = await cartResponse.json();
             // Calcular el valor del carrito excluyendo los samples
             currentPriceCents = cart.items.reduce((total, item) => {
                 const isSample = item.properties && item.properties.sample === 'true';
                 return total + (isSample ? 0 : item.final_line_price);
             }, 0);
        }

        if (currentPriceCents >= threshold) {
            // Cumple el umbral: Muestra el bloque
            samplesBlock.style.display = 'block';
        } else {
            // No cumple el umbral: Oculta el bloque
            samplesBlock.style.display = 'none';
        }
        
        // También verifica si necesitamos eliminar samples si el valor cayó por debajo del umbral.
        enforceEmptyCartRule();
    }
    
    // --- Core Logic: Sincronización con el Carrito (Eliminación y Adición Secuencial) ---
    async function syncSelectedSamplesWithCart(skipEnforcementCheck = false) {
        if (isSyncing) return;
        
        if (!skipEnforcementCheck) {
             const didEnforceRule = await enforceEmptyCartRule();
             if (didEnforceRule) return; 
        }
        
        startLoading();
        
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const desiredIds = Array.from(selectedVariantIds); 
        
        const existingSamples = cart.items.filter(i => 
            i.properties && i.properties.sample === 'true'
        );

        const idsToAdd = desiredIds; 
        
        let success = true;

        console.groupCollapsed(`🛒 INICIANDO SINCRONIZACIÓN: ${existingSamples.length} Samples Encontrados`);
        console.log('Samples a ELIMINAR:', existingSamples.map(i => ({ title: i.product_title, key: i.key, properties: i.properties })));
        console.log('Samples a AÑADIR:', idsToAdd);
        console.groupEnd();


        try {
            // A. REMOVER
            for (const item of existingSamples) {
                const removePayload = { id: item.key, quantity: 0 }; 
                await fetch('/cart/change.js', { 
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(removePayload)
                });
            }
            
            // B. AÑADIR
            if (idsToAdd.length > 0) {
                for (const id of idsToAdd) {
                    const addPayload = { 
                        id: parseInt(id, 10), 
                        quantity: 1,
                        properties: { "sample": "true" }
                    }; 
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(addPayload)
                    });
                }
            } 
            
        } catch (error) {
            console.error('❌ Error durante la sincronización de muestras (AJAX):', error);
            alert('Hubo un error al actualizar las muestras. Inténtalo de nuevo.');
            success = false;
        }

        stopLoading();
        
        if (success) {
            updateSelectedSampleUI(); 
            closePanel();
            refreshCartDrawer(); 
            // NO necesitamos toggleSamplesVisibility aquí si el MutationObserver está activo, 
            // ya que refreshCartDrawer() actualizará el precio y el Observer reaccionará.
        }
    }
    
    // --- Implementación de MutationObserver ---
    
    const observer = new MutationObserver((mutationsList, observer) => {
        // Ejecutamos la función de visibilidad cada vez que el contenido de texto del precio cambie.
        toggleSamplesVisibility(); 
    });

    const observerConfig = { characterData: true, subtree: true, childList: true };

    // 1. Llamar a la regla al cargar la página (para establecer la visibilidad inicial)
    loadSelectedSample();
    toggleSamplesVisibility(); 

    // 2. Iniciar el observador para reaccionar a los cambios de precio por AJAX
    observer.observe(cartPriceElement, observerConfig);
    
    
    // --- Event Listeners Antiguos (Mantener para funcionalidad) ---

    changeBtn && changeBtn.addEventListener('click', async function(e){
        e.preventDefault();

        // Verificar el umbral directamente con la función de visibilidad
        // (Aunque el observer lo haría automáticamente)
        await toggleSamplesVisibility();
        
        // Leer el estado actual del display (block/none) después de la comprobación
        if (samplesBlock.style.display === 'block') {
            openPanel();
        } else {
            console.warn(`El carrito total no alcanza el umbral mínimo (${threshold}c) para seleccionar muestras.`);
        }
    });
    
    closeBtn && closeBtn.addEventListener('click', function(e){ e.preventDefault(); closePanel(); });

    panel && panel.addEventListener('click', function(e){
        if (e.target === panel) closePanel();
    });

    // LÓGICA DE SELECCIÓN Y RESTRICCIÓN ESTRICTA
    sampleCards.forEach(card => {
        card.addEventListener('click', function() {
            if (isSyncing) return; 
            
            const vid = this.dataset.variantId;
            const isSelected = selectedVariantIds.has(vid);

            if (isSelected) {
                selectedVariantIds.delete(vid);
                this.classList.remove('is-selected');
                
            } else {
                if (selectedVariantIds.size >= maxSelect) {
                    this.classList.add('limit-reached');
                    setTimeout(() => this.classList.remove('limit-reached'), 600);
                    
                    console.warn(`🚫 Límite de ${maxSelect} samples alcanzado. Deselecciona uno antes de añadir otro.`);
                    return; 
                }
                
                selectedVariantIds.add(vid);
                this.classList.add('is-selected');
            }
            
            // Si la selección alcanza el máximo AHORA, disparamos la sincronización.
            if (selectedVariantIds.size === maxSelect) {
                syncSelectedSamplesWithCart();
                return;
            }
            
            // Actualizar la UI después de cualquier cambio local
            updatePanelUI();
            updateSelectedSampleUI();
        });
    });
});
// /* cart-samples.js - VERSIÓN FINAL Y COMPLETA (Regla de Carrito Vacío) */
// document.addEventListener('DOMContentLoaded', function() {
//     const root = document.getElementById('cart-samples-root');
//     const panel = document.getElementById('samples-side-panel');
//     if (!root || !panel) return;

//     // Obtener configuración del DOM
//     const maxSelect = parseInt(root.dataset.maxSelect || '1', 10);
//     const threshold = parseInt(root.dataset.threshold || '5000', 10);
    
//     // Selectores
//     const changeBtn = document.getElementById('cart-samples-change');
//     const closeBtn = document.getElementById('samples-close');
//     const sampleCards = document.querySelectorAll('.sample-card');
//     const samplePreviewSlot = document.getElementById('sample-preview-slot');
    
//     // Variables de estado
//     const STORAGE_KEY = 'selectedSampleVariantIds'; 
//     let selectedVariantIds = new Set(); 
//     let isSyncing = false; 

//     // ⚠️ FUNCIÓN CRÍTICA: Asegúrate de que esta función actualice el Side Cart.
//     function refreshCartDrawer() {
//         if (window.Cart && window.Cart.refresh) {
//             window.Cart.refresh(); 
//         } else if (document.querySelector('cart-drawer')) {
//             document.querySelector('cart-drawer').getCart();
//         } else {
//             console.warn('⚠️ La función de refresco del Side Cart (refreshCartDrawer) no está definida o accesible.');
//         }
//     }

//     // --- Funciones de Estado de Carga y Panel ---

//     const startLoading = () => {
//         isSyncing = true;
//         root.classList.add('is-loading'); 
//         panel.classList.add('is-loading');
//     };

//     const stopLoading = () => {
//         isSyncing = false;
//         root.classList.remove('is-loading');
//         panel.classList.remove('is-loading');
//     };

//     const openPanel = () => {
//         panel.setAttribute('aria-hidden', 'false');
//         panel.classList.add('opened');
//         document.body.classList.add('samples-panel-open'); 
//         updatePanelUI();
//     };

//     const closePanel = () => {
//         panel.setAttribute('aria-hidden', 'true');
//         panel.classList.remove('opened');
//         document.body.classList.remove('samples-panel-open');
//     };
    
//     // --- UI & Storage Functions ---
    
//     const updateSelectedSampleUI = () => {
//         const selectedData = [];
//         sampleCards.forEach(card => {
//             if (selectedVariantIds.has(card.dataset.variantId)) {
//                 selectedData.push({
//                     title: card.dataset.productTitle,
//                     imgSrc: card.dataset.img
//                 });
//             }
//         });

//         if (selectedData.length === 0) {
//             samplePreviewSlot.innerHTML = '<div class="no-samples"></div>';
//             localStorage.removeItem(STORAGE_KEY);
//             return;
//         }

//         const html = selectedData.map(data => `
//             <div class="selected-sample-item">
//                 <img src="${data.imgSrc}" alt="${data.title}" style="max-width: 50px; height: auto;">
//             </div>
//         `).join('');

//         samplePreviewSlot.innerHTML = html;
        
//         localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(selectedVariantIds)));
//     };
    
//     // 🔥 FUNCIÓN CLAVE: Añade/Quita la clase de desactivación
//     const updatePanelUI = () => {
//         const currentCount = selectedVariantIds.size;
//         const limitReached = currentCount === maxSelect;

//         sampleCards.forEach(card => {
//             const vid = card.dataset.variantId;
//             const isSelected = selectedVariantIds.has(vid);

//             // 1. Manejar la clase 'is-selected'
//             if (isSelected) {
//                 card.classList.add('is-selected');
//             } else {
//                 card.classList.remove('is-selected');
//             }

//             // 2. Manejar la clase de desactivación 'is-disabled-by-limit'
//             if (limitReached && !isSelected) {
//                 card.classList.add('is-disabled-by-limit');
//             } else {
//                 card.classList.remove('is-disabled-by-limit');
//             }
//         });
        
//         const panelTitle = panel.querySelector('h2');
//         if (panelTitle) {
//              panelTitle.innerHTML = `Choose your complimentary samples (${currentCount} of ${maxSelect} selected)`;
//         }
//     };

//     const loadSelectedSample = () => {
//         const storedIds = localStorage.getItem(STORAGE_KEY);
//         if (storedIds) {
//             try {
//                 const ids = JSON.parse(storedIds);
//                 if (Array.isArray(ids)) {
//                     selectedVariantIds = new Set(ids);
//                     updateSelectedSampleUI();
//                 }
//             } catch (e) {
//                 console.error("Error parsing stored sample data:", e);
//                 localStorage.removeItem(STORAGE_KEY);
//             }
//         }
//     };

//     // --- Lógica de la Regla de Carrito Vacío/Umbral ---
//     async function enforceEmptyCartRule() {
//         if (isSyncing) return;

//         const cartResponse = await fetch('/cart.js');
//         const cart = await cartResponse.json();

//         // 1. Identificar todos los samples y calcular su valor
//         const existingSamples = cart.items.filter(i => 
//             i.properties && i.properties.sample === 'true'
//         );
        
//         // Asumiendo que los samples son gratuitos (price: 0),
//         // pero por si acaso, verificamos el total_price del carrito.
//         // Si el total_price es igual a la suma de los samples (o 0),
//         // y el carrito no cumple el umbral, los samples deben eliminarse.

//         // En Shopify, si el carrito solo contiene samples (precio 0) y el umbral es > 0,
//         // el total_price (de pago) es 0, lo que no cumple el umbral.
        
//         // Verificamos si hay items pagados que cumplen el umbral.
//         const cartValueExcludingSamples = cart.items.reduce((total, item) => {
//             const isSample = item.properties && item.properties.sample === 'true';
//             return total + (isSample ? 0 : item.final_line_price);
//         }, 0);
        
//         // 2. Si el valor de los productos de pago no cumple el umbral Y hay samples seleccionados.
//         if (cartValueExcludingSamples < threshold && existingSamples.length > 0) {
            
//             console.warn('🚨 Regla de umbral violada. Eliminando samples gratuitos.');
            
//             // Borramos la selección local
//             selectedVariantIds.clear();

//             // Sincronizamos para borrar los samples del carrito (sin añadir nada)
//             await syncSelectedSamplesWithCart(true); // Usamos un flag para evitar el log de inicio redundante
            
//             // Refrescamos la UI local
//             updatePanelUI();
//             updateSelectedSampleUI();
            
//             return true; // Se ejecutó la eliminación
//         }
        
//         return false; // No se requirió la eliminación
//     }
    
//     // --- Core Logic: Sincronización con el Carrito (Eliminación y Adición Secuencial) ---
//     async function syncSelectedSamplesWithCart(skipEnforcementCheck = false) {
//         if (isSyncing) return;
        
//         // Solo verificamos la regla si no estamos llamando desde enforceEmptyCartRule
//         if (!skipEnforcementCheck) {
//              // Ejecutamos la verificación de la regla antes de sincronizar. 
//              // Si elimina, detiene la sincronización aquí.
//              const didEnforceRule = await enforceEmptyCartRule();
//              if (didEnforceRule) return; 
//         }
        
//         startLoading();
        
//         // 1. Obtener el estado actual del carrito
//         const cartResponse = await fetch('/cart.js');
//         const cart = await cartResponse.json();

//         const desiredIds = Array.from(selectedVariantIds); 
        
//         // Identificación CLAVE: Buscamos samples que tienen properties.sample = "true"
//         const existingSamples = cart.items.filter(i => 
//             i.properties && i.properties.sample === 'true'
//         );

//         const idsToAdd = desiredIds; 
        
//         let success = true;

//         console.groupCollapsed(`🛒 INICIANDO SINCRONIZACIÓN: ${existingSamples.length} Samples Encontrados`);
//         console.log('Samples a ELIMINAR:', existingSamples.map(i => ({ title: i.product_title, key: i.key, properties: i.properties })));
//         console.log('Samples a AÑADIR:', idsToAdd);
//         console.groupEnd();


//         try {
//             // A. REMOVER: Eliminar todos los samples existentes secuencialmente.
//             for (const item of existingSamples) {
//                 const removePayload = { id: item.key, quantity: 0 }; 
//                 console.log(`🗑️ Eliminando secuencialmente: "${item.title}" (key: ${item.key})`);
                
//                 await fetch('/cart/change.js', { 
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify(removePayload)
//                 });
//             }
            
//             console.log('✅ Eliminación de samples finalizada en el backend.');


//             // B. AÑADIR: Añadir los nuevos samples secuencialmente (garantiza que todos se registren).
//             if (idsToAdd.length > 0) {
//                 for (const id of idsToAdd) {
//                     const addPayload = { 
//                         id: parseInt(id, 10), 
//                         quantity: 1,
//                         properties: { "sample": "true" }
//                     }; 
//                     console.log(`➕ Añadiendo secuencialmente el Variant ID: ${id}`);

//                     await fetch('/cart/add.js', {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(addPayload)
//                     });
//                 }
//                 console.log('✅ Nuevos samples añadidos al carrito.');
//             } else {
//                  console.log('No hay nuevos samples para añadir.');
//             }
            
//         } catch (error) {
//             console.error('❌ Error durante la sincronización de muestras (AJAX):', error);
//             alert('Hubo un error al actualizar las muestras. Inténtalo de nuevo.');
//             success = false;
//         }

//         stopLoading();
        
//         if (success) {
//             updateSelectedSampleUI(); 
//             closePanel();
//             refreshCartDrawer(); 
//         }
//     }

//     // --- Event Listeners ---

//     // 1. Llamar a la regla al cargar la página (para limpiar samples si el carrito está vacío)
//     loadSelectedSample();
//     enforceEmptyCartRule();

//     changeBtn && changeBtn.addEventListener('click', async function(e){
//         e.preventDefault();

//         // Verificar el umbral (la regla ya limpia si es necesario)
//         let currentPrice = 0;
//         try {
//             const cartResponse = await fetch('/cart.js');
//             const cart = await cartResponse.json();
            
//             // Calculamos el valor de pago sin samples
//             currentPrice = cart.items.reduce((total, item) => {
//                 const isSample = item.properties && item.properties.sample === 'true';
//                 return total + (isSample ? 0 : item.final_line_price);
//             }, 0);

//         } catch (error) {
//             console.error("Error al obtener el carrito para verificar el umbral:", error);
//             currentPrice = threshold; 
//         }
        
//         if (currentPrice >= threshold) {
//             openPanel();
//         } else {
//             console.warn(`El carrito total no alcanza el umbral mínimo (${threshold}c) para seleccionar muestras.`);
//         }
//     });
    
//     closeBtn && closeBtn.addEventListener('click', function(e){ e.preventDefault(); closePanel(); });

//     panel && panel.addEventListener('click', function(e){
//         if (e.target === panel) closePanel();
//     });

//     // LÓGICA DE SELECCIÓN Y RESTRICCIÓN ESTRICTA
//     sampleCards.forEach(card => {
//         card.addEventListener('click', function() {
//             if (isSyncing) return; 
            
//             const vid = this.dataset.variantId;
//             const isSelected = selectedVariantIds.has(vid);

//             if (isSelected) {
//                 selectedVariantIds.delete(vid);
//                 this.classList.remove('is-selected');
                
//             } else {
//                 if (selectedVariantIds.size >= maxSelect) {
//                     this.classList.add('limit-reached');
//                     setTimeout(() => this.classList.remove('limit-reached'), 600);
                    
//                     console.warn(`🚫 Límite de ${maxSelect} samples alcanzado. Deselecciona uno antes de añadir otro.`);
//                     return; 
//                 }
                
//                 selectedVariantIds.add(vid);
//                 this.classList.add('is-selected');
//             }
            
//             // Si la selección alcanza el máximo AHORA, disparamos la sincronización.
//             if (selectedVariantIds.size === maxSelect) {
//                 syncSelectedSamplesWithCart();
//                 return;
//             }
            
//             // Actualizar la UI después de cualquier cambio local
//             updatePanelUI();
//             updateSelectedSampleUI();
//         });
//     });
// });